module.exports = __webpack_public_path__ + "img/service1.212ecf07.png";